import { BaseDto } from '@/shared/dtos/base-dto';

export class producto extends BaseDto {
    public liquidator_vendor_code !: string;
    public inventory_location !: string;
    public fc !: string;
    public iog !: number;
    public condicion !: string;
    public shipment_closed!: string;
    public bol !: string;
    public carrier !: string;
    public ship_to_city !: string;
    public removal_order_id !: string;
    public return_id !: string;
    public return_item_id !: string;
    public shipment_request_id !: string;
    public pkg_id !: string;
    public pallet_id !: string;
    public gl !: number;
    public department !: string;
    public gl_description !: string;
    public category_code !: number;
    public category !: string;
    public subcat_code !: number;
    public subcategory !: string;
    public asin !: string;
    public upc !: string;
    public ean !: string;
    public fcsku !: string;
    public item_desc !: string;
    public qty !: number;
    public item_pkg_weight !: number;
    public item_pkg_weight_uom !: string;
    public currency_code !: string;
    public cost !: number;
    public total_retail !: number;
    public total_cost !: number;
    public recovery_rate_type !: string;
    public adj_total_recovery !: number;
    public adj_recovery_rate !: number;
    public adj_reason !: string;
    public fnsku !: string;
    public lpn !: string;
    public listing_id !: string;
    public slot_size !: number;
    public is_parcel !: boolean;
    public date_in!: Date;
    public unit_retail !: number;
    public coste_compra !: number;
    public vendido !: boolean;
    public fecha_venta!: Date;
    public id_pedido !: number;
    public link_amazon !: string;
    public recibido !: boolean;
    public precio_vendido !: number;
    public estado !: number;

    public precio_amazon !: number;
    public mayorValor!: number;
    public mayorPrecioDeventa!: number;
    public ultimo_precio_amazon!: number;
    public desc_precio_amazon!: string;
    public precio_venta!: number;
    public ganado!: number;
} 
